import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';


const boxSx = {
    position: 'absolute',
    bottom: 0,
    width: '100%',
    backgroundColor: '#333',
    padding: '5px 10px',
    boxSizing: 'border-box',
    zIndex: 100
};

const dialogSx = {
    padding: '10px 15px',
    borderRadius: '10px',
    border: '8px solid #f3c645',
    backgroundColor: '#FFF',
    boxSizing: 'border-box',
    height: '150px',
    fontFamily: 'Monospace',
    fontSize: '35px',
    position: 'relative',
    overflowY: 'auto',
    '&::-webkit-scrollbar-track': {
        backgroundColor: '#DDD'
    },
    '&::-webkit-scrollbar': {
        width: '10px'
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#262626'
    }
};

const containerButtonsSx = {
    position: 'absolute',
    right: '32px',
    bottom: '12px',
    margin: '6px',
    display: 'flex',
    gap: '5px'
};

const buttonSx = {
    minWidth: '50px',
    borderRadius: '10px',
    boxShadow: 'inset -3px -3px 0 #CCC, 2px 2px 0 #444',
    border: '3px solid #444',
    fontWeight: 'bold',
    color: '#262626',
    '&:hover': {
        boxShadow: 'inset -2px -2px 0 #CCC, 1px 1px 0 #444'
    },
    '&:disabled': {
        boxShadow: 'inset -3px -3px 0 rgba(0, 0, 0, 0.05), 2px 2px 0 rgba(0, 0, 0, 0.12)',
        border: '3px solid rgba(0, 0, 0, 0.12)',
        color: 'rgba(0, 0, 0, 0.26)'
    }
};

const dialogTextSx = {
    marginRight: '105px',
    whiteSpace: 'pre-line',
    color: '#000'
};

const DialogBox = ({ children, onNext, onSkip, skipDisabled, nextDisabled }) => (
    <Box sx={boxSx}>
        <Box sx={dialogSx}>
            <Box sx={dialogTextSx}>
                {children}
            </Box>
        </Box>
        <Box sx={containerButtonsSx}>
            <Button variant="outlined" size="small" onClick={onSkip} sx={buttonSx} disabled={skipDisabled}>Skip</Button>
            <Button variant="outlined" size="small" onClick={onNext} sx={buttonSx} disabled={nextDisabled}><ArrowDropDownIcon /></Button>
        </Box>
    </Box>
);

export default DialogBox;